export default {
  app: {
    full: "操作现金市场系统", //"后端办公室",
    minimized: "操作现金市场系统", //"后台"
  },
  welcome: "欢迎回来，{user}！",
  login: "登录到您的帐户",
  relogin: "请重新登录您的帐户。",
  expired: "会话过期！",
  denied: "无权访问！",
  success: "你顺利完成了！",
  search_by_id_name: "按ID或名称搜索",
  search_by_id: "按ID搜索",
  change_user_status_confirm: "您确定要更改户口状态吗？",
  delete_confirm: "你确定你要删除 \"{name}\" 吗？",
  successful_change_password: "您已成功更改密码。",
  change_disable_confirm: "您确定要将这 \"{name}\" 更改为禁用吗？",
  select_option: "选择你的选择",
  no_data_available: "没有可用数据"
};
